import React from 'react';
import { connect, ConnectedProps } from '@cerebral/react';
import { useText } from 'common/hooks';

import SecondaryPage from 'challenge/common/KnowledgeComponents/SecondaryPage/Desktop';
import Summary from './Summary';
import {
  Wrapper,
  ColumnsWrapper,
  Column,
  TeamQuizGraph,
  LoggedActivitiesCard,
  NewQuiz,
} from './elements';
import { state, moduleSequences as sequences } from 'app/pwa/app.cerebral';

type Props = {
  readonly className?: string;
};

const deps = {
  tag: state.challenge.tagModal.key,
  score: state.challenge.tagModal.computedUserQuizScore,
  hasLoggedCurrentTag: state.challenge.tagModal.computedHasLoggedCurrentTag,
  toggleQuiz: sequences.challenge.tagModal.toggleQuiz,
  reviewQuiz: sequences.challenge.tagModal.reviewQuiz,
  goToActivities: sequences.challenge.tagModal.goToActivitiesClicked,
  showTagModalClicked: sequences.challenge.tagModal.showTagModalClicked,
};

function QuizEndPage({
  className,
  tag,
  score,
  hasLoggedCurrentTag,
  toggleQuiz,
  reviewQuiz,
  goToActivities,
  showTagModalClicked,
}: Props & typeof deps & ConnectedProps): React.ReactElement {
  const t = useText();

  return (
    <SecondaryPage
      className={className}
      backOnClick={() => toggleQuiz()}
      buttonText={t(`challenge.quiz.back.${tag}`)}
    >
      <Wrapper>
        <Summary
          score={score.value}
          totalQuestions={score.max}
          tag={tag}
          onReviewClicked={() => reviewQuiz()}
        />
        <ColumnsWrapper>
          <Column>
            <TeamQuizGraph width={192} height={133} />
            {!hasLoggedCurrentTag && (
              <LoggedActivitiesCard
                text={'Have you logged any energy activities today?'}
                buttonText={'Go to activities'}
                onClick={() => goToActivities()}
              />
            )}
          </Column>
          <Column>
            <NewQuiz
              text={'Take another quiz!'}
              onTagClick={passedTag =>
                showTagModalClicked({ tag: passedTag, openQuiz: true })
              }
            />
          </Column>
        </ColumnsWrapper>
      </Wrapper>
    </SecondaryPage>
  );
}

export default connect<Props, typeof deps>(deps, QuizEndPage);
